import { BundleResourcesPackage } from "resource-system";
import { Sound } from "@pixi/sound";
export class SoundResourcesPackage extends BundleResourcesPackage {
    public constructor() {
        super("SoundResourcesPackage");
    }
    public get assets_sounds_BuyShopItemSound_mp3(): Sound {
        return this.resource<Sound>("assets/sounds/BuyShopItemSound.mp3");
    }
    public get assets_sounds_CarrotEatingSound_mp3(): Sound {
        return this.resource<Sound>("assets/sounds/CarrotEatingSound.mp3");
    }
    public get assets_sounds_CollectCoinSound_mp3(): Sound {
        return this.resource<Sound>("assets/sounds/CollectCoinSound.mp3");
    }
    public get assets_sounds_ElectricitySound_mp3(): Sound {
        return this.resource<Sound>("assets/sounds/ElectricitySound.mp3");
    }
    public get assets_sounds_ExplosionSound_mp3(): Sound {
        return this.resource<Sound>("assets/sounds/ExplosionSound.mp3");
    }
    public get assets_sounds_FreezeSound_mp3(): Sound {
        return this.resource<Sound>("assets/sounds/FreezeSound.mp3");
    }
    public get assets_sounds_HitSound_mp3(): Sound {
        return this.resource<Sound>("assets/sounds/HitSound.mp3");
    }
    public get assets_sounds_TractorArrive_mp3(): Sound {
        return this.resource<Sound>("assets/sounds/TractorArrive.mp3");
    }
    public get assets_sounds_TurretShootSound_mp3(): Sound {
        return this.resource<Sound>("assets/sounds/TurretShootSound.mp3");
    }
    public get assets_sounds_music_level_mp3(): Sound {
        return this.resource<Sound>("assets/sounds/music/level.mp3");
    }
    public get assets_sounds_music_menu_mp3(): Sound {
        return this.resource<Sound>("assets/sounds/music/menu.mp3");
    }
}

